import { useEffect } from "react";

export default function useAutoClickChatButton() {
  useEffect(() => {
    const selector = ".rcw-launcher.rcw-hide-sm";

    const clickButtonIfExists = () => {
      const btn = document.querySelector(selector);
      if (btn) {
        btn.click();
        return true;
      }
      return false;
    };

    // Try immediately in case it’s already rendered
    if (clickButtonIfExists()) return;

    // Watch for new nodes (for dynamically injected scripts)
    const observer = new MutationObserver(() => {
      if (clickButtonIfExists()) observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);
}